import _ from 'lodash';
import i18n from '../../../i18n';
import Device from '../Device';
import { hwh } from './Common';

const questions = hwh.concat([{
  model: 'tricklestar',
  type: 'oauth',
  name: 'tricklestar',
  label: i18n.t('step3OauthDeviceTrickleStar'),
  showNext: false,
  required: true,
  advanceOnEnter: true,
  advanceOnValue: true,
  update: values => ({
    additionalFields: {
      type: 'gravity',
      mfg: 'tricklestar',
      tags: JSON.stringify(_.get(values, 'tags') || {}),
    },
  }),
}]);

const addDevice = async (values, context, signup) => {
  const promise = new Promise((resolve, reject) => {
    signup.$root.$on('oauth.redirect', () => {
      resolve();
    });
  });
  signup.$root.$emit('oauth.submit', values, context);
  return promise;
};

const TrickleStar = new Device('tricklestar', { mfg: 'tricklestar', questions, addDevice });

export default TrickleStar;
